"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GetTariffsElectricityProduct_1 = tslib_1.__importDefault(require("./GetTariffsElectricityProduct"));
const GetTariffsGasProduct_1 = tslib_1.__importDefault(require("./GetTariffsGasProduct"));
class GetTariffsBody extends base_models_1.Serializable {
    constructor() {
        super(...arguments);
        this.gasProducts = [];
        this.electricityProducts = [];
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({
        example: base_models_1.Brand.ENERGIEDIRECT,
        description: 'Some tariffs are only valid for EnergieDirect and vice versa for Essent.',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsBody.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType)),
    (0, base_models_1.Docs)({
        example: base_models_1.SegmentType.HH,
        description: 'We only check if it is household or not then it defaults to SME to be honest, since different rules and laws apply for not households.',
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsBody.prototype, "segment", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetTariffsGasProduct_1.default),
    tslib_1.__metadata("design:type", Array)
], GetTariffsBody.prototype, "gasProducts", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetTariffsElectricityProduct_1.default),
    tslib_1.__metadata("design:type", Array)
], GetTariffsBody.prototype, "electricityProducts", void 0);
exports.default = GetTariffsBody;
